<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('common_words.permits_system_info') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-5">
        <blockquote>
          <h5>{{ $t('common_words.global_permits') }}</h5>
          <p>
            {{ $t('common_words.global_permits_notice') }}
          </p>
          <el-tree
            :data="general_permissions"
            show-checkbox
            node-key="id"
            :default-expanded-keys="[0]"
            :default-checked-keys="model.general_permissions"
            :props="defaultProps"
            @check="handleGeneralPermissions"
            ref="general"
          >
          </el-tree>
        </blockquote>
      </div>
      <div class="col-7">
        <blockquote>
          <h5>{{ $t('common_words.specific_permits') }}</h5>
          <p>
            {{ $t('common_words.specific_permits_notice') }}
          </p>
          <el-tree
            :data="specific_permissions"
            show-checkbox
            node-key="id"
            :default-expanded-keys="[0]"
            :default-checked-keys="model.specific_permissions"
            :props="defaultProps"
            @check="handleSpecificPermissions"
            ref="specific"
          >
          </el-tree>
        </blockquote>
      </div>
    </div>
  </div>
</template>
<script>
import { assembleTreePermission } from 'src/util/Util';
import { Axios } from 'src/class/Axios.js';
import { mapActions } from 'vuex';
import { Tree } from 'element-ui';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  props: ['type', 'selected_modules'],

  components: {
    [Tree.name]: Tree,
  },

  data() {
    return {
      general_permissions: [],
      specific_permissions: [],
      specific_permissions_initial: [],
      model: {
        general_permissions: [],
        specific_permissions: [],
        selected_general_permissions: [],
        selected_specific_permissions: [],
      },
      defaultProps: {
        children: 'children',
        label: 'label',
      },
    };
  },

  watch: {
    type: function (newVal, oldVal) {
      this.setCheckedKeysTree(newVal);
    },

    selected_modules: function (newVal, oldVal) {
      this.specific_permissions = assembleTreePermission(
        newVal,
        this.specific_permissions_initial
      );
    },
  },

  mixins: [MixinPermissions, mixinMasters],

  methods: {
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
      buildPermissionsForTree: 'utils/buildPermissionsForTree',
    }),

    handleGeneralPermissions(data, checked) {
      this.model.general_permissions = checked.checkedKeys;
      this.model.selected_general_permissions = [];
      checked.checkedNodes.forEach((element) => {
        if (!element.children) {
          this.model.selected_general_permissions.push(element);
        }
      });
    },

    handleSpecificPermissions(data, checked) {
      this.model.specific_permissions = checked.checkedKeys;
      this.model.selected_specific_permissions = [];
      checked.checkedNodes.forEach((element) => {
        if (!element.children) {
          this.model.selected_specific_permissions.push(element);
        }
      });
    },

    validate() {
      return this.buildPermissionsForTree(
        this.model.selected_specific_permissions
      )
        .then((response) => {
          let general = JSON.parse(
            JSON.stringify(this.model.selected_general_permissions)
          );
          this.$emit('fillRoleForm', 'thirdStep', {
            selected_general_permissions: general.map((item) => {
              item.disabled = true;
              return item;
            }),
            selected_specific_permissions:
              this.buildDefaultArrayForTree(response),
          });
        })
        .then(() => {
          return true;
        });
    },

    setCheckedKeysTree(type) {
      if (type == 'super administrador' || type == 'administrador') {
        this.$refs.specific.setCheckedKeys([0]);
        this.$refs.general.setCheckedKeys([0]);
      } else {
        this.$refs.specific.setCheckedKeys(this.model.specific_permissions);
        this.$refs.general.setCheckedKeys(this.model.general_permissions);
      }
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);
      Axios.getMasters('permissions/treepermissions')
        .then((response) => {
          try {
            this.general_permissions =
              response.data.general[0] &&
              response.data.general[0].children.length === 0
                ? []
                : response.data.general;
          } catch (error) {
            console.log(error);
            this.general_permissions = [];
          }

          try {
            this.specific_permissions =
              response.data.specific[0] &&
              response.data.specific[0].children.length === 0
                ? []
                : response.data.specific;
          } catch (error) {
            console.log(error);
            this.specific_permissions = [];
          }

          this.specific_permissions_initial = JSON.parse(
            JSON.stringify(this.specific_permissions)
          );
          let editForm = {};

          if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            editForm = JSON.parse(sessionStorage.getItem('editForm'));
            this.model.general_permissions = editForm.general_permissions;
            this.model.selected_general_permissions =
              editForm.selected_general_permissions;

            this.model.specific_permissions = editForm.specific_permissions;
            this.model.selected_specific_permissions =
              editForm.selected_specific_permissions;
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else this.showHideLoading();
  },
};
</script>
<style></style>
